/**
 * The four dates get_creative_facts takes (spec §4.1, R13), from D1's windows: the period, the day the second half
 * starts, and the Result window's last day. Pure.
 *
 * @module services/creatives/creativeWindows
 */
import { addDays, rangeDays } from '@/services/looker/lookerDateRange';
import type { OverviewWindows } from '@/services/overview/overviewTypes';

export interface CreativeWindows {
  start: string;
  end: string;
  /** The second half's first day, start + ⌈n/2⌉: one day past `end` for a one-day period (no second half). */
  mid: string;
  /** D1's cut (today − 3 at the latest); null = no Result window. */
  resultEnd: string | null;
}

export const creativeWindowsOf = (w: OverviewWindows): CreativeWindows => ({
  start: w.current.start,
  end: w.current.end,
  mid: addDays(w.current.start, Math.ceil(rangeDays(w.current) / 2)),
  resultEnd: w.cut ? w.cut.end : null,
});

/** The read's key part (R13): two tokens that resolve to the same dates read once. */
export const creativeWindowsKey = (w: CreativeWindows): string => `${w.start}..${w.end}|${w.mid}|${w.resultEnd ?? '-'}`;
